<template>
  <div id="app">
    <div class="prompt">
      <div class="prompt_time">
        预报名时间：{{ dateDeal(schoolConfig.writeStartTime, true) }} —
        {{ dateDeal(schoolConfig.writeEndTime) }}
      </div>
      <div class="prompt_text">
        温馨提示：填写报名信息前，请先了解报名须知，然后准备好所需要的材料，居住证、户口本、房产证/合同、父母身份证等相关材料（以下需要上传图片地方，单张图片大小均不能10M）。
      </div>
    </div>
    <van-form @submit="onSubmit" :show-error-message="false" scroll-to-error>
      <!-- 学生姓名 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentName') !== -1
        "
        v-model="student.name"
        name="name"
        disabled
        input-align="right"
        label="学生姓名"
        placeholder="请输入学生姓名"
        :rules="[{ required: true, message: '请输入学生姓名' }]"
      />
      <!-- 学生身份证号 -->
      <van-field
        v-model="student.idNumber"
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentIdcard') !== -1
        "
        name="idNumber"
        input-align="right"
        label="学生身份证号"
        @blur="idNumberBlur"
        disabled
        :maxlength="18"
        placeholder="请输入学生身份证号"
        :rules="[
          { required: true, message: '请输入学生身份证号' },
          { pattern: idCardreg, message: '请填写正确的身份证号' },
        ]"
      />
      <!-- @touchstart.native.stop="idNumberShow = true" -->
      <van-number-keyboard
        v-model="student.idNumber"
        :show="idNumberShow"
        extra-key="X"
        close-button-text="完成"
        @blur="idNumberBlur"
      />
      <!-- idNumberShow = false -->
      <!-- 学生出生日期 -->
      <van-field
        readonly
        clickable
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentBirthday') !==
          -1
        "
        name="dateBirth"
        input-align="right"
        :value="student.dateBirth"
        disabled
        label="学生出生日期"
        placeholder="点击选择出生日期"
        :rules="[{ required: true, message: '请选择出生日期' }]"
      />
      <!-- @click="showCalendar = true" -->
      <van-calendar
        v-model="showCalendar"
        :min-date="minDate"
        @confirm="dateBirthConfirm"
      />

      <!-- 学生出生日期 -->
      <!-- 性别 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentSexStr') !== -1
        "
        name="sex"
        input-align="right"
        label="学生性别"
      >
        <template #input>
          <van-radio-group
            disabled
            v-model="student.sex"
            direction="horizontal"
          >
            <van-radio name="1">女</van-radio>
            <van-radio name="0">男</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 性别 -->
      <!-- 民族 -->
      <van-field
        readonly
        clickable
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentNation') !== -1
        "
        name="nation"
        input-align="right"
        :value="student.nation"
        label="民族"
        placeholder="点击选择民族"
        right-icon="arrow-down"
        :rules="[{ required: true, message: '点击选择民族' }]"
        @click="nationPicker = true"
      />
      <van-popup v-model="nationPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="nationList"
          @confirm="nationConfirm"
          @cancel="nationPicker = false"
        />
      </van-popup>
      <!-- 民族 -->
      <!-- 身高 -->
      <!-- readonly
        clickable -->
      <van-field
        name="height"
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentHeight') !== -1
        "
        input-align="right"
        label="身高"
        type="number"
        placeholder="请输入学生身高"
        v-model="student.height"
        :rules="[{ required: true, message: '请输入学生身高' }]"
      >
        <template #extra> &nbsp; cm </template>
      </van-field>
      <!-- @touchstart.native.stop="heightShow = true" -->
      <van-number-keyboard
        v-model="student.height"
        :show="heightShow"
        :maxlength="3"
        @blur="heightShow = false"
      />
      <!-- 身高 -->
      <!-- 体重 -->
      <!-- readonly
        clickable -->
      <van-field
        name="weight"
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentWeight') !== -1
        "
        input-align="right"
        label="体重"
        type="number"
        placeholder="请输入学生体重"
        v-model="student.weight"
        :rules="[{ required: true, message: '请输入学生体重' }]"
      >
        <template #extra>&nbsp; Kg </template>
      </van-field>
      <!-- @touchstart.native.stop="weightShow = true" -->
      <van-number-keyboard
        v-model="student.weight"
        :show="weightShow"
        :maxlength="3"
        @blur="weightShow = false"
      />
      <!-- 体重 -->
      <!-- 特殊情况 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentRemark') !== -1
        "
        v-model="student.special"
        rows="2"
        autosize
        name="special"
        input-align="right"
        label="学生特殊情况"
        :rules="[
          {
            required: true,
            message:
              '请真实填写学生的情况,如：是否有过敏史、遗传病、残疾等、没有情况填写无',
          },
        ]"
        type="textarea"
        placeholder="请真实填写学生的情况，如：是否有过敏史、遗传病、残疾等、没有情况填写无"
      />
      <!-- 特殊情况 -->

      <!-- 学生籍贯 -->
      <van-field
        v-if="
          dynamicForm.findIndex(
            (item) => item.field == 'studentNativePlace'
          ) !== -1
        "
        v-model="student.NativePlace"
        name="NativePlace"
        input-align="right"
        label="籍贯"
        :rules="[{ required: true, message: '请填写籍贯' }]"
        placeholder="参照户口本"
      />
      <!-- 学生籍贯 -->
      <!-- 学生户口类别 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'residenceTypeName') !==
          -1
        "
        readonly
        clickable
        name="categoryName"
        input-align="right"
        :value="student.categoryName"
        label="户口类别"
        placeholder="点击选择户口类别"
        right-icon="arrow-down"
        :rules="[{ required: true, message: '点击选择户口类别' }]"
        @click="categoryPicker = true"
      />
      <van-popup v-model="categoryPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="categoryNameData"
          @confirm="categoryConfirm"
          @cancel="categoryPicker = false"
        />
      </van-popup>
      <!-- 学生户口类别 -->
      <!-- 学生户住类型 -->
      <van-field
        readonly
        clickable
        v-if="
          dynamicForm.findIndex((item) => item.field == 'residenceInfoName') !==
          -1
        "
        name="familiesName"
        input-align="right"
        :value="student.familiesName"
        label="户住类型"
        placeholder="点击选择户住类型"
        right-icon="arrow-down"
        :rules="[{ required: true, message: '点击选择户住类型' }]"
        @click="familiesPicker = true"
      />
      <van-popup v-model="familiesPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="familiesNameData"
          @confirm="familiesConfirm"
          @cancel="familiesPicker = false"
        />
      </van-popup>
      <!-- 学生户住类型 -->
      <!-- 学生户口性质 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentHkxzStr') !== -1
        "
        readonly
        clickable
        name="registerName"
        input-align="right"
        :value="student.registerName"
        label="户口性质"
        placeholder="点击选择户口性质"
        right-icon="arrow-down"
        :rules="[{ required: true, message: '点击选择户口性质' }]"
        @click="registerPicker = true"
      />
      <van-popup v-model="registerPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="registerNameList"
          @confirm="registerConfirm"
          @cancel="registerPicker = false"
        />
      </van-popup>
      <!-- 学生户口性质 -->
      <!-- 学生户口所在地 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentHkszd') !== -1
        "
        v-model="student.registeredHome"
        rows="2"
        name="registeredHome"
        autosize
        input-align="right"
        label="学生户口所在地"
        type="textarea"
        :rules="[{ required: true, message: '请填写学生户口所在地' }]"
        placeholder="参照学生户口本首页的红章处XX省XX市XX区XX派出所"
      />
      <!-- 学生户口所在地 -->
      <!-- 学生出生地 -->
      <van-field
        v-if="
          dynamicForm.findIndex(
            (item) => item.field == 'studentBornAddress'
          ) !== -1
        "
        v-model="student.placeBirth"
        name="placeBirth"
        input-align="right"
        label="学生出生地"
        :rules="[{ required: true, message: '请填写学生出生地' }]"
        placeholder="请输入学生出生地"
      />
      <!-- 现住址： -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'addressName') !== -1
        "
        readonly
        clickable
        name="communityName"
        input-align="right"
        :value="student.communityName"
        label="现住址"
        placeholder="点击选择现住址"
        right-icon="arrow-down"
        :rules="[{ required: true, message: '点击选择现住址' }]"
        @click="communityPicker = true"
      />
      <van-popup v-model="communityPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="communityNameData"
          @confirm="communityConfirm"
          @cancel="communityPicker = false"
        />
      </van-popup>
      <!-- 详细住址 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'addressDetail') !== -1
        "
        v-model="student.detaAddress"
        rows="2"
        autosize
        name="detaAddress"
        input-align="right"
        label="详细住址"
        :rules="[
          {
            required: true,
            message: '请填写与选择的小区一致的具体地址，学校将进行实地家访',
          },
        ]"
        type="textarea"
        placeholder="请填写与选择的小区一致的具体地址，学校将进行实地家访"
      />
      <!-- 办事处 -->
      <van-field
        v-if="
          dynamicForm.findIndex(
            (item) => item.field == 'addressSubdistriceOffice'
          ) !== -1
        "
        v-model="student.addressOffice"
        name="addressOffice"
        input-align="right"
        label="办事处"
        :disabled="!!student.addressOffice"
        placeholder="请输入所在办事处"
        :rules="[{ required: true, message: '请输入所在办事处' }]"
      />
      <!-- 社区 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'addressCommunity') !==
          -1
        "
        v-model="student.addressCommunity"
        name="addressCommunity"
        input-align="right"
        label="社区"
        :disabled="!!student.addressCommunity"
        placeholder="请输入所在社区"
        :rules="[{ required: true, message: '请输入所在社区' }]"
      />
      <!-- 学生联系电话 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentPhone') !== -1
        "
        v-model="student.comPhone"
        name="comPhone"
        input-align="right"
        label="学生联系电话"
        :rules="[
          { required: true, message: '请填写经常辅导接送孩子家长的常用电话' },
          { pattern, message: '请填写正确手机号' },
        ]"
        placeholder="填写经常辅导接送孩子家长的常用电话"
      />
      <!-- 学生联系电话 -->
      <!-- 是否进城务工人员随迁子女（学生是郑州市外户口） -->
      <van-field
        name="migWorkers"
        v-if="
          dynamicForm.findIndex(
            (item) => item.field == 'isWorkerChildrenStr'
          ) !== -1
        "
      >
        <template #input>
          <div>
            <div>是否进城务工人员随迁子女</div>
            <van-radio-group
              v-model="student.migWorkers"
              direction="horizontal"
            >
              <van-radio name="0">否</van-radio>
              <van-radio name="1">是</van-radio>
            </van-radio-group>
          </div>
        </template>
      </van-field>
      <!-- 是否独生子女 -->
      <van-field
        name="oneChild"
        input-align="right"
        label="是否独生子女"
        v-if="
          dynamicForm.findIndex((item) => item.field == 'isOnlyChildrenStr') !==
          -1
        "
      >
        <template #input>
          <van-radio-group v-model="student.oneChild" direction="horizontal">
            <van-radio name="0">否</van-radio>
            <van-radio name="1">是</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 是否留守儿童 -->
      <van-field
        name="behindChildren"
        input-align="right"
        label="是否留守儿童"
        v-if="
          dynamicForm.findIndex((item) => item.field == 'isStayChildrenStr') !==
          -1
        "
      >
        <template #input>
          <van-radio-group
            v-model="student.behindChildren"
            direction="horizontal"
          >
            <van-radio name="0">否</van-radio>
            <van-radio name="1">是</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 是否烈士或优抚子女 -->
      <van-field
        name="aboutChildren"
        input-align="right"
        label="是否烈士或优抚子女"
        v-if="
          dynamicForm.findIndex(
            (item) => item.field == 'isMartyrChildrenStr'
          ) !== -1
        "
      >
        <template #input>
          <van-radio-group
            v-model="student.aboutChildren"
            direction="horizontal"
          >
            <van-radio name="0">否</van-radio>
            <van-radio name="1">是</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 学生曾用名 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentAlias') !== -1
        "
        v-model="student.formerName"
        name="formerName"
        input-align="right"
        label="学生曾用名"
        :rules="[{ required: true, message: '请填写学生的曾用名，没有填无' }]"
        placeholder="请填写学生的曾用名，没有填无"
      />
      <!-- 毕业幼儿园 -->
      <van-field
        v-if="
          dynamicForm.findIndex(
            (item) => item.field == 'studentNurserySchool'
          ) !== -1
        "
        v-model="student.kindergarten"
        name="kindergarten"
        input-align="right"
        label="毕业幼儿园"
        :rules="[{ required: true, message: '请填写学生的毕业幼儿园' }]"
        placeholder="请填写学生的毕业幼儿园"
      />
      <!-- 学生血型 -->
      <van-field
        v-if="
          dynamicForm.findIndex(
            (item) => item.field == 'studentBloodTypeStr'
          ) !== -1
        "
        readonly
        clickable
        name="bloodTypeName"
        input-align="right"
        :value="student.bloodTypeName"
        label="学生血型"
        placeholder="点击选择学生血型"
        right-icon="arrow-down"
        :rules="[{ required: true, message: '请选择学生血型' }]"
        @click="bloodPicker = true"
      />
      <van-popup v-model="bloodPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="bloodNameList"
          @confirm="bloodConfirm"
          @cancel="bloodPicker = false"
        />
      </van-popup>
      <!-- 学生特长： -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentSpecialty') !==
          -1
        "
        v-model="student.specialty"
        rows="2"
        autosize
        name="specialty"
        input-align="right"
        label="学生特长"
        :rules="[{ required: true, message: '请填写一下孩子的爱好特长' }]"
        type="textarea"
        placeholder="请填写一下孩子的爱好特长"
      />
      <!-- 父亲姓名： -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'fatherName') !== -1
        "
        v-model="father.name"
        name="fname"
        input-align="right"
        label="父亲姓名"
        :rules="[{ required: true, message: '请填写父亲的姓名' }]"
        placeholder="请填写父亲的姓名"
      />
      <!-- 父亲电话： -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'fatherMobile') !== -1
        "
        v-model="father.phone"
        name="fphone"
        type="tel"
        input-align="right"
        label="父亲电话"
        :rules="[
          { required: true, message: '请填写父亲的电话' },
          { pattern, message: '请填写正确手机号' },
        ]"
        placeholder="请填写父亲的电话"
      />
      <!-- 父亲工作单位： -->
      <van-field
        v-if="
          dynamicForm.findIndex(
            (item) => item.field == 'fatherWorkerAddress'
          ) !== -1
        "
        v-model="father.WorkUnits"
        name="fWorkUnits"
        input-align="right"
        label="父亲工作单位"
        :rules="[{ required: true, message: '请填写父亲工作单位' }]"
        placeholder="父亲工作单位"
      />
      <!-- 父亲的职务： -->
      <van-field
        v-if="dynamicForm.findIndex((item) => item.field == 'fatherJob') !== -1"
        v-model="father.position"
        name="fposition"
        input-align="right"
        label="父亲职务"
        :rules="[{ required: true, message: '请填写父亲的职务' }]"
        placeholder="请填写职务"
      />

      <!-- 父亲身份证号 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'fatherIdcard') !== -1
        "
        v-model="father.idNumber"
        name="fidNumber"
        input-align="right"
        label="父亲身份证号"
        :maxlength="18"
        placeholder="请输入父亲身份证号"
        :rules="[
          { required: true, message: '请填写父亲身份证号' },
          { pattern: idCardreg, message: '请填写正确身份证号' },
        ]"
      />
      <!-- @touchstart.native.stop="idNumberFatherShow = true" -->
      <van-number-keyboard
        v-model="father.idNumber"
        :show="idNumberFatherShow"
        extra-key="X"
        close-button-text="完成"
        @blur="idNumberFatherShow = false"
      />
      <!-- 父亲民族 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'fatherNation') !== -1
        "
        readonly
        clickable
        name="fnation"
        input-align="right"
        :value="father.nation"
        label="父亲民族"
        placeholder="点击选择民族"
        right-icon="arrow-down"
        :rules="[{ required: true, message: '请选择父亲民族' }]"
        @click="nationPickerFather = true"
      />
      <van-popup v-model="nationPickerFather" position="bottom">
        <van-picker
          show-toolbar
          :columns="nationList"
          @confirm="nationConfirmFather"
          @cancel="nationPickerFather = false"
        />
      </van-popup>
      <!-- 父亲特长： -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'fatherSpecialty') !==
          -1
        "
        v-model="father.specialty"
        rows="2"
        name="fspecialty"
        autosize
        input-align="right"
        label="父亲特长"
        type="textarea"
        :rules="[{ required: true, message: '请填写一下父亲的爱好特长' }]"
        placeholder="请填写一下父亲的爱好特长"
      />
      <!-- 母亲姓名： -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'motherName') !== -1
        "
        v-model="mother.name"
        name="mname"
        input-align="right"
        label="母亲姓名"
        :rules="[{ required: true, message: '请填写母亲的姓名' }]"
        placeholder="请填写母亲的姓名"
      />
      <!-- 母亲电话： -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'motherMobile') !== -1
        "
        v-model="mother.phone"
        name="mphone"
        type="tel"
        input-align="right"
        label="母亲电话"
        :rules="[
          { required: true, message: '请填写母亲的电话' },
          { pattern, message: '请填写正确手机号' },
        ]"
        placeholder="请填写母亲的电话"
      />
      <!-- 母亲工作单位： -->
      <van-field
        v-if="
          dynamicForm.findIndex(
            (item) => item.field == 'motherWorkerAddress'
          ) !== -1
        "
        v-model="mother.WorkUnits"
        name="mWorkUnits"
        input-align="right"
        label="母亲工作单位"
        :rules="[{ required: true, message: '请填写母亲的工作单位' }]"
        placeholder="母亲工作单位"
      />
      <!-- 母亲的职务： -->
      <van-field
        v-if="dynamicForm.findIndex((item) => item.field == 'motherJob') !== -1"
        v-model="mother.position"
        name="mposition"
        input-align="right"
        label="母亲职务"
        :rules="[{ required: true, message: '请填写母亲的职务' }]"
        placeholder="请填写职务"
      />

      <!-- 母亲身份证号 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'motherIdcard') !== -1
        "
        v-model="mother.idNumber"
        name="midNumber"
        input-align="right"
        label="母亲身份证号"
        :maxlength="18"
        placeholder="请输入母亲身份证号"
        :rules="[
          { required: true, message: '请输入母亲身份证号' },
          { pattern: idCardreg, message: '请填写正确身份证号' },
        ]"
      />
      <!-- @touchstart.native.stop="idNumberMotherShow = true" -->
      <van-number-keyboard
        v-model="mother.idNumber"
        :show="idNumberMotherShow"
        extra-key="X"
        close-button-text="完成"
        @blur="idNumberMotherShow = false"
      />
      <!-- 母亲民族 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'motherNation') !== -1
        "
        readonly
        clickable
        name="mnation"
        input-align="right"
        :value="mother.nation"
        label="母亲民族"
        placeholder="点击选择民族"
        :rules="[{ required: true, message: '请选择母亲的民族' }]"
        right-icon="arrow-down"
        @click="nationPickerMother = true"
      />
      <van-popup v-model="nationPickerMother" position="bottom">
        <van-picker
          show-toolbar
          :columns="nationList"
          @confirm="nationConfirmMother"
          @cancel="nationPickerMother = false"
        />
      </van-popup>
      <!-- 母亲特长： -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'motherSpecialty') !==
          -1
        "
        v-model="mother.specialty"
        name="mspecialty"
        rows="2"
        autosize
        input-align="right"
        label="母亲特长"
        type="textarea"
        :rules="[{ required: true, message: '请填写一下母亲的爱好特长' }]"
        placeholder="请填写一下母亲的爱好特长"
      />
      <!-- 学生照片： -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'studentPhoto') !== -1
        "
        label-width="1.5rem"
        name="headerImage"
        label="学生照片"
      >
        <template #input>
          <div>
            <div class="index_color">两寸蓝底近照</div>
            <van-uploader
              v-model="student.headerImage"
              :after-read="headerAfterRead"
              :before-delete="studentDeleteRead"
              :before-read="studentBeforeRead"
              :max-count="1"
              :max-size="10240 * 1024"
              @oversize="onOversize"
            />
          </div>
        </template>
      </van-field>
      <!-- 学生出生医学证明： -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'birthPhoto') !== -1
        "
        label-width="1.5rem"
        name="birthPhoto"
        label="学生出生医学证明"
      >
        <template #input>
          <div>
            <van-uploader
              v-model="birthPhoto"
              deletable
              :after-read="birthPhotoAfterRead"
              :before-delete="birthPhotoDeleteRead"
              :before-read="accountBeforeRead"
              :max-count="1"
              :max-size="10240 * 1024"
              @oversize="onOversize"
            />
            <div class="index_color">
              户主不是父母或父母孩子户口不在一个本上，必须上传
            </div>
          </div>
        </template>
      </van-field>
      <!-- 儿童预防接种证 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'vaccinationPhoto') !==
          -1
        "
        label-width="1.5rem"
        name="vaccinationPhoto"
        label="儿童预防接种证"
      >
        <template #input>
          <div>
            <van-uploader
              v-model="vaccinationPhoto"
              deletable
              :after-read="vaccinationPhotoAfterRead"
              :before-delete="vaccinationPhotoDeleteRead"
              :before-read="accountBeforeRead"
              :max-count="1"
              :max-size="10240 * 1024"
              @oversize="onOversize"
            />
            <div class="index_color">
              疫苗本第一页
            </div>
          </div>
        </template>
      </van-field>
      <!-- 户口照片： -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'registPhoto') !== -1
        "
        label-width="1.5rem"
        name="accountImg"
        label="户口照片"
      >
        <template #input>
          <div>
            <van-uploader
              v-model="accountImg"
              deletable
              :after-read="accountAfterRead"
              :before-delete="accountDeleteRead"
              :before-read="accountBeforeRead"
              :max-count="9"
              :max-size="10240 * 1024"
              @oversize="onOversize"
            />
            <div class="index_color">
              户口本首页，父/母页本人页，学生本人页
              （如果父、母、学生户口本不在一个户口本上
              需要分别上传父、母户口本首页和父、母本页人，学生页）（图片不能大于10M）
            </div>
          </div>
        </template>
      </van-field>
      <!-- 居住证，房产证或合同 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'permitPhoto') !== -1
        "
        label-width="1.5rem"
        name="realImg"
        label="居住证，房产证或合同"
      >
        <template #input>
          <div>
            <!-- <div>居住证，房产证或合同</div> -->
            <van-uploader
              v-model="realImg"
              :after-read="realAfterRead"
              :before-delete="realDeleteRead"
              :before-read="realBeforeRead"
              deletable
              :max-count="9"
              :max-size="10240 * 1024"
              @oversize="onOversize"
            />
            <div class="index_color">
              房产证、合同或拆迁安置协议下附文字：房产证首页、第二页、第三页，或购房合同买卖双方信息页、最后一张签字盖章页、购房发票；或拆迁安置协议；不动产登记信息查询记录（图片不能大于10M）
            </div>
          </div>
        </template>
      </van-field>
       <!-- 工作证明 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'workingPhoto') !==
          -1
        "
        label-width="1.5rem"
        name="workingPhoto"
        label="工作证明"
      >
        <template #input>
          <div>
            <van-uploader
              v-model="workingPhoto"
              deletable
              :after-read="workingPhotoAfterRead"
              :before-delete="workingPhotoDeleteRead"
              :before-read="accountBeforeRead"
              :max-count="1"
              :max-size="10240 * 1024"
              @oversize="onOversize"
            />
            <div class="index_color">
              父母一方与用人单位签订的劳动合同或工商行政部门颁发的营业执照（本市外户口必须上传，劳动合同签字盖章页）
            </div>
          </div>
        </template>
      </van-field>
       <!-- 父母身份证 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'parentsIdcard') !==
          -1
        "
        label-width="1.5rem"
        name="parentsIdcard"
        label="父母身份证"
      >
        <template #input>
          <div>
            <van-uploader
              v-model="parentsIdcard"
              deletable
              :after-read="parentsIdcardAfterRead"
              :before-delete="parentsIdcardDeleteRead"
              :before-read="accountBeforeRead"
              :max-count="9"
              :max-size="10240 * 1024"
              @oversize="onOversize"
            />
            <div class="index_color">
              父母双方身份证正反面
            </div>
          </div>
        </template>
      </van-field>
       <!-- 父母结婚证（离婚证或离婚协议） -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'parentsMarriage') !==
          -1
        "
        label-width="1.5rem"
        name="parentsMarriage"
        label="父母结婚证（离婚证或离婚协议）"
      >
        <template #input>
          <div>
            <van-uploader
              v-model="parentsMarriage"
              deletable
              :after-read="parentsMarriageAfterRead"
              :before-delete="parentsMarriageDeleteRead"
              :before-read="accountBeforeRead"
              :max-count="9"
              :max-size="10240 * 1024"
              @oversize="onOversize"
            />
            <div class="index_color">
              户主不是父母，或者父母孩子户口不在一个本上（单亲的需要上传离婚证和离婚协议）
            </div>
          </div>
        </template>
      </van-field>
       <!-- 房查信息 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'homeInfo') !==
          -1
        "
        label-width="1.5rem"
        name="homeInfo"
        label="房查信息"
      >
        <template #input>
          <div>
            <van-uploader
              v-model="homeInfo"
              deletable
              :after-read="homeInfoAfterRead"
              :before-delete="homeInfoDeleteRead"
              :before-read="accountBeforeRead"
              :max-count="9"
              :max-size="10240 * 1024"
              @oversize="onOversize"
            />
            <div class="index_color">
              一家人在本市均没有房产或只在报名学校所属区内有一处房产且未交房，需要上传父母孩子一家人的本市房管局的房查信息。
            </div>
          </div>
        </template>
      </van-field>
       <!-- 暂住证和租房材料 -->
      <van-field
        v-if="
          dynamicForm.findIndex((item) => item.field == 'rentingMaterial') !==
          -1
        "
        label-width="1.5rem"
        name="rentingMaterial"
        label="暂住证和租房材料"
      >
        <template #input>
          <div>
            <van-uploader
              v-model="rentingMaterial"
              deletable
              :after-read="rentingMaterialAfterRead"
              :before-delete="rentingMaterialDeleteRead"
              :before-read="accountBeforeRead"
              :max-count="9"
              :max-size="10240 * 1024"
              @oversize="onOversize"
            />
            <div class="index_color">
              租房材料包括：租房协议、房主身份证正反面、房主房本、入住消费记录等资料。
            </div>
          </div>
        </template>
      </van-field>
      <div style="margin: 16px">
        <van-button type="info" round native-type="submit" block
          >提交报名资料</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import {
  dictCode,
  upload,
  selectResidence,
  selectBySchool,
  saveEnrollmentStudent,
  getSchoolConfig,
  getStudentByIdcard,
  getEnrollmentStudent,
  getDynamicForm,
} from "@/api/home";
import nationList from "../../static/nation.json";
export default {
  data() {
    return {
      schoolId: "",
      schoolName: "",
      schoolConfig: {},
      state: -1,
      nationList: nationList.nationList,
      nationPicker: false,
      heightShow: false,
      weightShow: false,
      showCalendar: false,
      idNumberShow: false,
      nationPickerFather: false,
      idNumberFatherShow: false,
      nationPickerMother: false,
      idNumberMotherShow: false,
      registerPicker: false,
      bloodPicker: false,
      categoryPicker: false,
      familiesPicker: false,
      communityPicker: false,
      isJPG: false,
      pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
      idCardreg:
        /^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}[\dXx]$/,
      minDate: new Date(2010, 0, 1),
      id: "",
      student: {
        name: "",
        sex: "0",
        nation: "",
        height: "",
        weight: "",
        special: "",
        dateBirth: "",
        idNumber: "",
        kindergarten: "",
        NativePlace: "",
        categoryName: "",
        categoryCode: "",
        familiesName: "",
        familiesCode: "",
        registeredHome: "",
        communityName: "",
        communityCode: "",
        addressOffice: "",
        addressCommunity: "",
        placeBirth: "",
        comPhone: "",
        migWorkers: "0",
        oneChild: "0",
        behindChildren: "0",
        aboutChildren: "0",
        formerName: "",
        specialty: "",
        detaAddress: "",
        registerName: "",
        registerCode: "",
        bloodTypeName: "",
        bloodTypeCode: "",
        headerImage: [],
        headerImages: [],
      },
      father: {
        name: "",
        phone: "",
        WorkUnits: "",
        position: "",
        nation: "",
        specialty: "",
        idNumber: "",
      },
      mother: {
        name: "",
        phone: "",
        WorkUnits: "",
        position: "",
        nation: "",
        specialty: "",
        idNumber: "",
      },
      accountImg: [],
      accountImgs: [],
      realImg: [],
      realImgs: [],
      registerList: [],
      registerNameList: [],
      bloodList: [],
      bloodNameList: [],
      categoryData: [],
      categoryNameData: [],
      familiesData: [],
      familiesNameData: [],
      communityData: [],
      communityNameData: [],
      dynamicForm: [],
      birthPhoto: [],
      birthPhotos: [],
      vaccinationPhoto: [],
      vaccinationPhotos: [],
      workingPhoto: [],
      workingPhotos: [],
      parentsIdcards:[],
      parentsIdcard:[],
      parentsMarriages:[],
      parentsMarriage:[],
      homeInfo:[],
      homeInfos:[],
      rentingMaterial:[],
      rentingMaterials:[],
    };
  },
  created() {
    this.student.idNumber = this.$route.query.idCard;
    this.schoolId = this.$route.query.schoolId;
    // this.schoolName = this.$route.query.schoolName;
    this.student.name = this.$route.query.studentName;
    this.state = this.$route.query.state;
    this.id = this.$route.query.id;
    this.bloodType();
    this.idNumberBlur();
    this.selectResidence(1);
    this.selectResidence(2);
    this.selectBySchool();
    this.getSchoolConfig();
    this.getDynamicForm();
  },
  mounted() {},
  methods: {
    // 根据身份证号查询已填写信息
    getStudentByIdcard() {
      let params = {
        id: this.id,
      };
      getEnrollmentStudent(params).then((res) => {
        if (res.data.code == 0) {
          let studentInfo = res.data.data;
          this.id = studentInfo.id;
          this.student.addressCommunity = studentInfo.addressCommunity;
          this.student.detaAddress = studentInfo.addressDetail;
          this.student.communityCode = studentInfo.addressId;
          this.student.communityName = studentInfo.addressName;
          this.student.addressOffice = studentInfo.addressSubdistriceOffice;
          this.student.aboutChildren = studentInfo.isMartyrChildren + "";
          this.student.oneChild = studentInfo.isOnlyChildren + "";
          this.student.behindChildren = studentInfo.isStayChildren + "";
          this.student.migWorkers = studentInfo.isWorkerChildren + "";
          this.student.familiesName = studentInfo.residenceInfoName;
          this.student.familiesCode = studentInfo.residencerInfoId;
          this.student.categoryCode = studentInfo.residenceTypeId;
          this.student.categoryName = studentInfo.residenceTypeName;
          this.student.formerName = studentInfo.studentAlias;
          this.student.dateBirth = studentInfo.studentBirthday;
          this.student.bloodTypeCode = studentInfo.studentBloodType;
          this.student.placeBirth = studentInfo.studentBornAddress;
          this.student.height = studentInfo.studentHeight + "";
          this.student.registeredHome = studentInfo.studentHkszd;
          this.student.registerCode = studentInfo.studentHkxz;
          this.student.studentIdcard = studentInfo.idNumber;
          this.student.name = studentInfo.studentName;
          this.student.nation = studentInfo.studentNation;
          this.student.kindergarten = studentInfo.studentNurserySchool;
          this.student.comPhone = studentInfo.studentPhone;
          this.student.special = studentInfo.studentRemark;
          this.student.sex = studentInfo.studentSex + "";
          this.student.specialty = studentInfo.studentSpecialty;
          this.student.weight = studentInfo.studentWeight + "";
          this.student.NativePlace = studentInfo.studentNativePlace;

          this.father.idNumber = studentInfo.fatherIdcard;
          this.father.position = studentInfo.fatherJob;
          this.father.phone = studentInfo.fatherMobile;
          this.father.name = studentInfo.fatherName;
          this.father.nation = studentInfo.fatherNation;
          this.father.specialty = studentInfo.fatherSpecialty;
          this.father.WorkUnits = studentInfo.fatherWorkerAddress;

          this.mother.idNumber = studentInfo.motherIdcard;
          this.mother.position = studentInfo.motherJob;
          this.mother.phone = studentInfo.motherMobile;
          this.mother.name = studentInfo.motherName;
          this.mother.nation = studentInfo.motherNation;
          this.mother.specialty = studentInfo.motherSpecialty;
          this.mother.WorkUnits = studentInfo.motherWorkerAddress;
          this.registerList.forEach((item) => {
            if (this.student.registerCode == item.code) {
              this.student.registerName = item.name;
            }
          });
          this.bloodList.forEach((item) => {
            if (this.student.bloodTypeCode == item.code) {
              this.student.bloodTypeName = item.name;
            }
          });
          studentInfo.enrollmentStudentAnnexList.forEach((item) => {
            if (item.annexType == 1) {
              let obj = {
                url: item.annexUrl,
              };
              this.student.headerImages.push(obj);
              this.student.headerImage.push(obj);
            }
            if (item.annexType == 2) {
              let obj = {
                url: item.annexUrl,
              };
              this.accountImgs.push(obj);
              this.accountImg.push(obj);
            }
            if (item.annexType == 3) {
              let obj = {
                url: item.annexUrl,
              };
              this.realImgs.push(obj);
              this.realImg.push(obj);
            }
            if (item.annexType == 4) {
              let obj = {
                url: item.annexUrl,
              };
              this.birthPhotos.push(obj);
              this.birthPhoto.push(obj);
            }
            if (item.annexType == 5) {
              let obj = {
                url: item.annexUrl,
              };
              this.vaccinationPhotos.push(obj);
              this.vaccinationPhoto.push(obj);
            }
            if (item.annexType == 6) {
              let obj = {
                url: item.annexUrl,
              };
              this.workingPhotos.push(obj);
              this.workingPhoto.push(obj);
            }
            if (item.annexType == 7) {
              let obj = {
                url: item.annexUrl,
              };
              this.parentsIdcard.push(obj);
              this.parentsIdcards.push(obj);
            }
            if (item.annexType == 8) {
              let obj = {
                url: item.annexUrl,
              };
              this.parentsMarriages.push(obj);
              this.parentsMarriage.push(obj);
            }
            if (item.annexType == 9) {
              let obj = {
                url: item.annexUrl,
              };
              this.homeInfos.push(obj);
              this.homeInfo.push(obj);
            }
            if (item.annexType == 10) {
              let obj = {
                url: item.annexUrl,
              };
              this.rentingMaterial.push(obj);
              this.rentingMaterials.push(obj);
            }
          });
        }
      });
    },
    //   表单提交事件
    onSubmit(val) {
      console.log(val);
      let studentPhoto = this.dynamicForm.findIndex(
        (item) => item.field == "studentPhoto"
      );
      let registPhoto = this.dynamicForm.findIndex(
        (item) => item.field == "registPhoto"
      );
      let permitPhoto = this.dynamicForm.findIndex(
        (item) => item.field == "permitPhoto"
      );
      let birthPhoto = this.dynamicForm.findIndex(
        (item) => item.field == "birthPhoto"
      );
      let vaccinationPhoto = this.dynamicForm.findIndex(
        (item) => item.field == "vaccinationPhoto"
      );
      let workingPhoto = this.dynamicForm.findIndex(
        (item) => item.field == "workingPhoto"
      );
      let parentsIdcard = this.dynamicForm.findIndex(
        (item) => item.field == "parentsIdcard"
      );
      let parentsMarriage = this.dynamicForm.findIndex(
        (item) => item.field == "parentsMarriage"
      );
      let homeInfo = this.dynamicForm.findIndex(
        (item) => item.field == "homeInfo"
      );
      let rentingMaterial = this.dynamicForm.findIndex(
        (item) => item.field == "rentingMaterial"
      );
      if (studentPhoto !== -1 && val.headerImage.length == 0) {
        this.$toast("请上传学生照片");
        return false;
      }
      if (registPhoto !== -1 && val.accountImg.length == 0) {
        this.$toast("请上传户口照片");
        return false;
      }
      if (permitPhoto !== -1 && val.realImg.length == 0) {
        this.$toast("请上传居住证，房产证或合同照片");
        return false;
      }
      if (parentsIdcard !== -1 && val.parentsIdcard.length == 0) {
        this.$toast("请上传父母身份证照片");
        return false;
      }
      if (vaccinationPhoto !== -1 && val.vaccinationPhoto.length == 0) {
        this.$toast("请上传儿童预防接种证照片");
        return false;
      }
      if (
        studentPhoto !== -1 &&
        val.headerImage.length != this.student.headerImages.length
      ) {
        this.$toast("请检查图片是否上传完成");
        return false;
      }
      if (
        registPhoto !== -1 &&
        val.accountImg.length != this.accountImgs.length
      ) {
        this.$toast("请检查图片是否上传完成");
        return false;
      }
      if (permitPhoto !== -1 && val.realImg.length != this.realImgs.length) {
        this.$toast("请检查图片是否上传完成");
        
        return false;
      }
      if (birthPhoto !== -1 && val.birthPhoto.length != this.birthPhotos.length) {
        this.$toast("请检查图片是否上传完成");
        console.log(this.birthPhotos);
        return false;
      }
      if (vaccinationPhoto !== -1 && val.vaccinationPhoto.length != this.vaccinationPhotos.length) {
        this.$toast("请检查图片是否上传完成");
        console.log(this.vaccinationPhotos);
        return false;
      }
      if (workingPhoto !== -1 && val.workingPhoto.length != this.workingPhotos.length) {
        this.$toast("请检查图片是否上传完成");
        console.log(this.workingPhotos);
        return false;
      }
      if (parentsIdcard !== -1 && val.parentsIdcard.length != this.parentsIdcards.length) {
        this.$toast("请检查图片是否上传完成");
        console.log(this.parentsIdcards);

        return false;
      }
      if (parentsMarriage !== -1 && val.parentsMarriage.length != this.parentsMarriages.length) {
        this.$toast("请检查图片是否上传完成");
         console.log(this.parentsMarriages);
        return false;
      }
      if (homeInfo !== -1 && val.homeInfo.length != this.homeInfos.length) {
        this.$toast("请检查图片是否上传完成");
        console.log(this.homeInfos);
        return false;
      }
      if (rentingMaterial !== -1 && val.rentingMaterial.length != this.rentingMaterials.length) {
        this.$toast("请检查图片是否上传完成");
        console.log(this.rentingMaterials);
        return false;
      }
      let enrollmentStudentAnnexList = [];
      this.student.headerImages.forEach((item) => {
        let obj = {
          annexType: 1,
          annexUrl: item.url,
        };
        enrollmentStudentAnnexList.push(obj);
      });
      this.accountImgs.forEach((item) => {
        let obj = {
          annexType: 2,
          annexUrl: item.url,
        };
        enrollmentStudentAnnexList.push(obj);
      });
      this.realImgs.forEach((item) => {
        let obj = {
          annexType: 3,
          annexUrl: item.url,
        };
        enrollmentStudentAnnexList.push(obj);
      });
      this.birthPhotos.forEach((item) => {
        let obj = {
          annexType: 4,
          annexUrl: item.url,
        };
        enrollmentStudentAnnexList.push(obj);
      });
      this.vaccinationPhotos.forEach((item) => {
        let obj = {
          annexType: 5,
          annexUrl: item.url,
        };
        enrollmentStudentAnnexList.push(obj);
      });
       this.workingPhotos.forEach((item) => {
        let obj = {
          annexType: 6,
          annexUrl: item.url,
        };
        enrollmentStudentAnnexList.push(obj);
      });
       this.parentsIdcards.forEach((item) => {
        let obj = {
          annexType: 7,
          annexUrl: item.url,
        };
        enrollmentStudentAnnexList.push(obj);
      });
      this.parentsMarriages.forEach((item) => {
        let obj = {
          annexType: 8,
          annexUrl: item.url,
        };
        enrollmentStudentAnnexList.push(obj);
      });
      this.homeInfos.forEach((item) => {
        let obj = {
          annexType: 9,
          annexUrl: item.url,
        };
        enrollmentStudentAnnexList.push(obj);
      });
      this.rentingMaterials.forEach((item) => {
        let obj = {
          annexType: 10,
          annexUrl: item.url,
        };
        enrollmentStudentAnnexList.push(obj);
      });
      if (enrollmentStudentAnnexList.length == 0) {
        enrollmentStudentAnnexList = "";
      }
      let params = {
        schoolId: this.schoolId,
        schoolName: this.schoolName,
        fatherIdcard: val.fidNumber,
        fatherJob: val.fposition,
        fatherMobile: val.fphone,
        fatherName: val.fname,
        fatherNation: val.fnation,
        fatherSpecialty: val.fspecialty,
        fatherWorkerAddress: val.fWorkUnits,

        motherIdcard: val.midNumber,
        motherJob: val.mposition,
        motherMobile: val.mphone,
        motherName: val.mname,
        motherNation: val.mnation,
        motherSpecialty: val.mspecialty,
        motherWorkerAddress: val.mWorkUnits,

        addressCommunity: val.addressCommunity,
        addressDetail: val.detaAddress,
        addressId: this.student.communityCode,
        addressName: val.communityName,
        addressSubdistriceOffice: val.addressOffice,
        isMartyrChildren: val.migWorkers,
        isOnlyChildren: val.oneChild,
        isStayChildren: val.behindChildren,
        isWorkerChildren: val.migWorkers,
        residenceInfoName: val.familiesName,
        residencerInfoId: this.student.familiesCode,
        residenceTypeId: this.student.categoryCode,
        residenceTypeName: val.categoryName,
        studentAlias: val.formerName,
        studentBirthday: val.dateBirth,
        studentBloodType: this.student.bloodTypeCode,
        studentBornAddress: val.placeBirth,
        studentHeight: val.height,
        studentHkszd: val.registeredHome,
        studentHkxz: this.student.registerCode,
        studentIdcard: val.idNumber,
        studentName: val.name,
        studentNation: val.nation,
        studentNativePlace: val.NativePlace,
        studentNurserySchool: val.kindergarten,
        studentPhone: val.comPhone,
        studentRemark: val.special,
        studentSex: val.sex,
        studentSpecialty: val.specialty,
        studentWeight: val.weight,
      };
      if (enrollmentStudentAnnexList.length !== 0) {
        params.enrollmentStudentAnnexList = enrollmentStudentAnnexList;
      }
      if (this.state == 1) {
        params.id = this.id;
      }
      saveEnrollmentStudent(params).then((res) => {
        if (res.data.code == 0) {
          this.$toast("提交成功,将在两秒后跳转到录取状态页面");
          setTimeout(() => {
            this.$router.push({
              path: "/state",
              query: {
                schoolId: this.schoolId,
                idCard: val.idNumber,
                studentName: val.name,
              },
            });
          }, 2000);
          return false;
        }
        this.$toast(res.data.msg);
      });
    },
    // 根据学校ID查询学校基础配置信息
    getSchoolConfig() {
      getSchoolConfig({
        schoolId: this.schoolId,
      }).then((res) => {
        let data = res.data.data;
        this.schoolConfig = data;
        this.schoolName = res.data.data.schoolName;
      });
    },
    getDynamicForm() {
      let params = {
        schoolId: this.schoolId,
      };
      getDynamicForm(params).then((res) => {
        this.dynamicForm = res.data.data;
      });
    },
    dateDeal(str, flag = false) {
      let data = "";
      if (flag) {
        data = str.slice(0, -3);
      }
      if (!flag) {
        data = str.slice(5, -3);
      }
      return data;
    },
    // 学生民族确认事件
    nationConfirm(val) {
      this.student.nation = val;
      this.nationPicker = false;
    },
    // 通过身份证获取性别和出生年月日
    idNumberBlur() {
      let sex = this.student.idNumber.slice(-2, -1);
      const str = this.student.idNumber;
      const y = str.slice(6, 10);
      const m = str.slice(10, 12);
      const d = str.slice(12, 14);
      this.student.dateBirth = y + "-" + m + "-" + d;
      if (sex % 2 == 0) {
        this.student.sex = "1";
      } else {
        this.student.sex = "0";
      }
      this.idNumberShow = false;
    },
    // 出生日期
    dateBirthConfirm(date) {
      this.student.dateBirth = `${date.getFullYear()}/${
        date.getMonth() + 1
      }/${date.getDate()}`;
      this.showCalendar = false;
    },
    // 父亲民族确认事件
    nationConfirmFather(val) {
      this.father.nation = val;
      this.nationPickerFather = false;
    },
    // 母亲民族确认事件
    nationConfirmMother(val) {
      this.mother.nation = val;
      this.nationPickerMother = false;
    },
    // 学生照片 蓝底
    headerAfterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let prarms = new FormData();
      prarms.append("file", file.file);
      upload(prarms).then((res) => {
        this.student.headerImages.push(res.data.data[0]);
        file.status = "";
        file.message = "";
      });
    },
    // 学生照片 删除回调
    studentDeleteRead(file, detail) {
      this.student.headerImages.splice(detail.index, 1);
      return true;
    },
    // 学生照片 限制
    studentBeforeRead(file) {
      if (file.type === "image/jpeg" || file.type === "image/png") {
        this.isJPG = true;
      }
      if (!this.isJPG) {
        this.$toast("只能是 JPG或者PNG 格式!");
      }
      return this.isJPG;
    },
    // 学生出生医学证明
    birthPhotoAfterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let prarms = new FormData();
      prarms.append("file", file.file);
      upload(prarms).then((res) => {
        this.birthPhotos.push(res.data.data[0]);
        file.status = "";
        file.message = "";
      });
    },
    //  学生出生医学证明 删除回调
    birthPhotoDeleteRead(file, detail) {
      this.birthPhotos.splice(detail.index, 1);
      return true;
    },
    // 儿童预防接种证
    vaccinationPhotoAfterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let prarms = new FormData();
      prarms.append("file", file.file);
      upload(prarms).then((res) => {
        this.vaccinationPhotos.push(res.data.data[0]);
        file.status = "";
        file.message = "";
      });
    },
    //  儿童预防接种证 删除回调
    vaccinationPhotoDeleteRead(file, detail) {
      this.vaccinationPhotos.splice(detail.index, 1);
      return true;
    },
    // 户口照片 蓝底
    accountAfterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let prarms = new FormData();
      prarms.append("file", file.file);
      upload(prarms).then((res) => {
        this.accountImgs.push(res.data.data[0]);
        file.status = "";
        file.message = "";
      });
    },
    // 户口照片 删除回调
    accountDeleteRead(file, detail) {
      this.accountImgs.splice(detail.index, 1);
      // this.accountImgs.forEach((item, index) => {
      //   if (item.originalFilename == file.file.name) {
      //     this.accountImgs.splice(index, 1);
      //   }
      // });
      return true;
    },
    // 户口照片 限制
    accountBeforeRead(file) {
      if (file.type === "image/jpeg" || file.type === "image/png") {
        this.isJPG = true;
      }
      if (!this.isJPG) {
        this.$toast.fail("只能是 JPG或者PNG 格式!");
      }
      return this.isJPG;
    },
    // 房产照片
    realAfterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let prarms = new FormData();
      prarms.append("file", file.file);
      upload(prarms).then((res) => {
        this.realImgs.push(res.data.data[0]);
        file.status = "";
        file.message = "";
      });
    },
    // 房产照片 删除回调
    realDeleteRead(file, detail) {
      this.realImgs.splice(detail.index, 1);
      return true;
    },
    // 房产照片 限制
    realBeforeRead(file) {
      if (file.type === "image/jpeg" || file.type === "image/png") {
        this.isJPG = true;
      }
      if (!this.isJPG) {
        this.$toast.fail("只能是 JPG或者PNG 格式!");
      }
      return this.isJPG;
    },
    // 工作证明
    workingPhotoAfterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let prarms = new FormData();
      prarms.append("file", file.file);
      upload(prarms).then((res) => {
        this.workingPhotos.push(res.data.data[0]);
        file.status = "";
        file.message = "";
      });
    },
    //  工作证明 删除回调
    workingPhotoDeleteRead(file, detail) {
      this.workingPhotos.splice(detail.index, 1);
      return true;
    },
     // 父母身份证
    parentsIdcardAfterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let prarms = new FormData();
      prarms.append("file", file.file);
      upload(prarms).then((res) => {
        this.parentsIdcards.push(res.data.data[0]);
        console.log(this.parentsIdcards);
        file.status = "";
        file.message = "";
      });
    },
    //  父母身份证 删除回调
    parentsIdcardDeleteRead(file, detail) {
      this.parentsIdcards.splice(detail.index, 1);
      return true;
    },
      // 父母结婚证（离婚证或离婚协议）
    parentsMarriageAfterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let prarms = new FormData();
      prarms.append("file", file.file);
      upload(prarms).then((res) => {
        this.parentsMarriages.push(res.data.data[0]);
        file.status = "";
        file.message = "";
      });
    },
    //  父母结婚证（离婚证或离婚协议） 删除回调
    parentsMarriageDeleteRead(file, detail) {
      this.parentsMarriages.splice(detail.index, 1);
      return true;
    },
      // 房查信息
    homeInfoAfterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let prarms = new FormData();
      prarms.append("file", file.file);
      upload(prarms).then((res) => {
        this.homeInfos.push(res.data.data[0]);
        file.status = "";
        file.message = "";
      });
    },
    //  房查信息 删除回调
    homeInfoDeleteRead(file, detail) {
      this.homeInfos.splice(detail.index, 1);
      return true;
    },
      // 暂住证和租房材料
    rentingMaterialAfterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let prarms = new FormData();
      prarms.append("file", file.file);
      upload(prarms).then((res) => {
        this.rentingMaterials.push(res.data.data[0]);
        file.status = "";
        file.message = "";
      });
    },
    //  暂住证和租房材料 删除回调
    rentingMaterialDeleteRead(file, detail) {
      this.rentingMaterials.splice(detail.index, 1);
      return true;
    },
    // 照片大小限制
    onOversize() {
      this.$toast("图片最大不能超过10M");
    },
    // 获取户口性质列表
    householdRegister() {
      let params = {
        code: "residence_type",
      };
      dictCode(params).then((res) => {
        let data = res.data.data;
        this.registerList = data;
        data.forEach((item) => {
          this.registerNameList.push(item.name);
        });
        // 获取已填报信息
        if (this.state == 1) {
          this.getStudentByIdcard();
        }
      });
    },
    // 户口性质确认
    registerConfirm(val) {
      this.registerList.forEach((item) => {
        if (item.name == val) {
          this.student.registerCode = item.code;
        }
      });
      this.student.registerName = val;
      this.registerPicker = false;
    },
    // 获取血型列表
    bloodType() {
      let params = {
        code: "blood_type",
      };
      dictCode(params).then((res) => {
        let data = res.data.data;
        this.bloodList = data;
        data.forEach((item) => {
          this.bloodNameList.push(item.name);
        });
        this.householdRegister();
      });
    },
    // 血型确认
    bloodConfirm(val) {
      this.bloodList.forEach((item) => {
        if (item.name == val) {
          this.student.bloodTypeCode = item.code;
        }
      });
      this.student.bloodTypeName = val;
      this.bloodPicker = false;
    },
    // 查询学生户口信息 1.学生户口类别 2.学生户住情况
    selectResidence(type) {
      let params = {
        schoolId: this.schoolId,
        residenceType: type,
      };
      selectResidence(params).then((res) => {
        let data = res.data.data;
        if (type == 1) {
          this.categoryData = data;
          data.forEach((item) => {
            this.categoryNameData.push(item.studentResidenceName);
          });
        } else {
          this.familiesData = data;
          data.forEach((item) => {
            this.familiesNameData.push(item.studentResidenceName);
          });
        }
      });
    },
    // 户口类别 确认
    categoryConfirm(val) {
      this.student.categoryName = val;
      this.categoryData.forEach((item) => {
        if (item.studentResidenceName == val) {
          this.student.categoryCode = item.id;
        }
      });
      this.categoryPicker = false;
    },
    // 户住类型 确认
    familiesConfirm(val) {
      this.student.familiesName = val;
      this.familiesData.forEach((item) => {
        if (item.studentResidenceName == val) {
          this.student.familiesCode = item.id;
        }
      });
      this.familiesPicker = false;
    },
    // 根据学校ID查询该校下所有的符合报名的小区
    selectBySchool() {
      selectBySchool({
        schoolId: this.schoolId,
      }).then((res) => {
        let data = res.data.data;
        this.communityData = data;
        data.forEach((item) => {
          this.communityNameData.push(item.addressName);
        });
      });
    },
    // 现住址 确认
    communityConfirm(val) {
      this.student.communityName = val;
      this.communityData.forEach((item) => {
        if (item.addressName == val) {
          this.student.communityCode = item.id;
          this.student.addressCommunity = item.addressCommunity;
          this.student.addressOffice = item.addressSubdistriceOffice;
        }
      });
      this.communityPicker = false;
    },
  },
};
</script>
<style scoped>
.prompt {
  padding: 0px 0.37rem;
}
.prompt_text {
  padding-top: 0.37rem;
  font-size: 0.32rem;
  color: #ff4d3e;
}
.prompt_time {
  margin-top: 0.4rem;
  font-size: 0.37rem;
  color: #999999;
}
.index_color {
  color: #999999;
}
</style>


// WEBPACK FOOTER //
// src/view/index.vue